export default {
    HEADER: 'Place',
    PLACEHOLDER_NAME: 'Enter place name',
    LABEL_NAME: 'Place name',
    PLACEHOLDER_MIN_ORDER_AMOUNT: 'Minimum order amount',
    LABEL_MIN_ORDER_AMOUNT: 'Minimum amount',
    PLACEHOLDER_PHONE_NUMBER: 'Enter phone number',
    LABEL_PHONE_NUMBER: 'Phone number',
    LABEL_COMPANY: 'Company',
    LABEL_TERMINAL: 'Terminal',
    LABEL_WEBSITE: 'Website',
    PLACEHOLDER_COUNTRY: 'Enter country',
    LABEL_COUNTRY: 'Country',
    PLACEHOLDER_STREET: 'Enter street',
    LABEL_STREET: 'Street',
    PLACEHOLDER_STREET_NUMBER: 'Enter street number',
    LABEL_STREET_NUMBER: 'Number',
    PLACEHOLDER_CITY: 'Enter city',
    LABEL_CITY: 'City',
    PLACEHOLDER_ZIP_CODE: 'Enter zip code',
    LABEL_ZIP_CODE: 'Zip code',
    PLACEHOLDER_FLOOR: 'Enter floor',
    LABEL_FLOOR: 'Floor',
    PLACEHOLDER_APARTMENT: 'Enter apartment',
    LABEL_APARTMENT: 'Apartment',
    PLACEHOLDER_DESCRIPTION: 'Enter description',
    LABEL_DESCRIPTION: 'Description',
    PLACEHOLDER_LONGITUDE: 'Enter longitude',
    LABEL_LONGITUDE: 'Longitude',
    PLACEHOLDER_LATITUDE: 'Enter latitude',
    LABEL_LATITUDE: 'Latitude',
    LABEL_DELIVERY_ZONES_PRICES: 'Delivery prices per zone',
    LABEL_DELIVERY_ZONES_PRICE: 'Price',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
    LABEL_WORKING_HOURS: 'Working hours',
    LABEL_OPENING_TIME: 'Opening time',
    LABEL_CLOSING_TIME: 'Closing time',
    LABEL_CLOSED: 'Closed',
    LABEL_DAY_MONDAY: 'Monday',
    LABEL_DAY_TUESDAY: 'Tuesday',
    LABEL_DAY_WEDNESDAY: 'Wednesday',
    LABEL_DAY_THURSDAY: 'Thursday',
    LABEL_DAY_FRIDAY: 'Friday',
    LABEL_DAY_SATURDAY: 'Saturday',
    LABEL_DAY_SUNDAY: 'Sunday',
};
